import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";

interface UseAgreementsDataProps {
	partnershipId: string;
	date: string;
}

export function useAgreementsData({ partnershipId, date }: UseAgreementsDataProps) {
	const { organization } = useAuth();

	const query = useQuery({
		queryKey: ["partner", "agreements", partnershipId, "hourly-rate", date],
		queryFn: async () => {
			if (!organization?.id) throw new Error("No organization found");
			const response = await client.organizations[":orgId"].partnerships[
				":partnershipId"
			].agreements[":agreementType"].$get({
				param: {
					orgId: guardString(organization.id),
					partnershipId,
					agreementType: "hourly-rate",
				},
				query: {
					agreementId: undefined,
					date,
				},
			});
			return responseHandler(response);
		},
	});

	return {
		...query,
		agreementsData: query.data,
		hourlyRate: query.data?.active?.value,
	};
}
